import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=3b6bda3c&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b6bda3c')) {
      api.createRecord('3b6bda3c', component.options)
    } else {
      api.reload('3b6bda3c', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=3b6bda3c&", function () {
      api.rerender('3b6bda3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8v8mtGChIa9zX/JS/comp/IncreaseNumber.vue"
export default component.exports